export default __webpack_public_path__ + "static/media/documents_green.9a4c1d72.svg";